import React from "react";

import { getLabel } from "../../../../hooks/use-labels";
import ConfirmationModal from "../../../../components/HexModal/ConfirmationModal";

const EmptyCartConfirmation = ({ onClose, onEmpty, description,loading }) => {
  return (
    <ConfirmationModal
      open={true}
      loading={loading}
      onCancel={onClose}
      onConfirm={onEmpty}
      cancelText={getLabel("noLabel")}
      confirmText={getLabel("yesLabel")}
      title={getLabel("emptyCartLabel")}
      confirmDescription={description}
    />
  );
};

export default EmptyCartConfirmation;
